<template>
<div>
    <!-- fixed-bottom-nav -->
    <!-- <div class="bottombar-large" style="margin-top:5em; margin-left: -2em; width: 400px;"> -->
    <div class="bottombar-large" style="margin-top:5em; margin-left: -2em; width: 100%;">
        <div style="padding-left:1em;">
            <a href="/"><i class="fa fa-list"></i><br><span>Feeds</span></a>
            <a href="/shop"><i class="fa fa-shopping-bag"></i><br><span>Bag</span></a>
            <a href="/account"><i class="fa fa-search"></i><br><span>Account</span></a>
            <a href="/notifications"><i class="fa fa-bell"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Notifications</span></a>
            <a href="/cart"><i class="fa fa-user"></i><br><span>Account</span></a>
            <!-- <a href="#news" style="font-size:22px;"><i class="fa fa-plus"></i><span>Add</span></a> -->
        </div>
    </div>

    <!---mobile-->
    <!-- <div class="bottombar" style="margin-top:15em; margin-left: -2em;width: 150%;"> -->
    <div class="bottombar">
        <!-- <div style="margin-left:2.5em;"> -->
        <div>
            <!-- <a href="/"><i id="m_home" class="fas fa-store-alt"></i><br><span>Home</span></a>-->
            <a id="a_home" href="/" style="display: block;"><i id="m_home" class="fas fa-store-alt"></i><br><span>Home</span></a>
            <a id="a_search" href="/" style="display: none; width: 14%;"><i id="m_search" class="fas fa-search"></i><br><span>Search</span></a>
            <a id="a_store" :href="set_store_url" style="display: none; width: 22%;"><i id="m_store" class="fas fa-store-alt"></i><br><span>Store</span></a>
            <a href="/placed/orders"><i id="m_orders" class="fas fa-shopping-basket"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Orders</span></a>
            <a href="/placed/orders"><i id="m_orders" class="fas fa-shopping-basket"></i><sup v-if="notifications_alert > 0" class="notify-alert">{{notifications_alert}}</sup><br><span>Deals</span></a>
            <a href="/settings"><i id="m_settings" class="fas fa-cog"></i><br><span>Settings</span></a>
        </div>
    </div>
    <!--./mobile-->
   
    <!--./ fixed-bottom-nav -->
 </div>
</template>

<style>
    .bottombar{
        /* margin-bottom: 2em;
        margin-right: 4em;
        margin-left: 3em; 
        width: 80%;
        border-radius: 18px; */
        background-color: #f9f9f9;
        padding: 0.8em 0.4em;
    }
    .bottombar a {
        /* width: 32%; */
        width: 20.88%;
        line-height: 0.2;
        color: #f5d33e;
        font-size: 1.4em;
    }
    .bottombar a i{
        color: #0e0d0d;
    }.bottombar a span{
        color: #0e0d0d;
    }
    .notify-alert{
        background: #ff3c00;
        color: #ffffff;
        font-size: 11px;
        padding: 0.2em 0.42em;
        border-radius: 50%;
    }
</style>


<script>
import services from './../../services/service'; // Service Class
//
import AccountResources from './../../pages/Account/Resources/commonfunctions.js';
//
let service = new services();

export default {
    name: 'MenuBottom',
    mixins: [AccountResources],
    data () {
        return {
            path:this.$route.path,
            user:{},
            notifications:{},
            notifications_alert:0,
            active_shop_together_alert:0,
            //
            //-seturls
            set_store_url:'',

        }
    },

    methods: {
        preset() {
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    self.getNotifications();
                    //check if has sellpoints
                    self.getSellpoints(self.user.user_id);
                }else {
                    // self.$router.push('login');
                }
            });
        },

        reSetLinks(type){
            if(type == 1){
                //
                this.set_store_url = '/dashboard';
                //
                document.getElementById("a_home").style.display = "none";
                document.getElementById("a_search").style.display = "block";
                document.getElementById("a_store").style.display = "block";
                //
                if(this.path == "/"){document.getElementById("m_search").style.color = "#ffe600";}
                if(this.path == "/"+this.sellpoint.business_username){
                    document.getElementById("m_store").style.color = "#ffe600";
                }
            }else{
                this.set_store_url = '/'+this.sellpoint.business_username;
            }
        },

        getNotifications(){
            service.getNotifications(this, this.user.user_id).then(response => {
                if(response.body.status == 200) {
                    this.notifications_alert = response.body.data_alert_total;
                }
            }).catch((err) => {})
        },
    },

    mounted: function() {
        let path = this.$route.path;
        if(path == "/"){document.getElementById("m_home").style.color = "#ffe600";document.getElementById("m_search").style.color = "#ffe600";}
        if(path == "/orders"){document.getElementById("m_orders").style.color = "#ffe600";}
        if(path == "/placed/orders"){document.getElementById("m_orders").style.color = "#ffe600";}
        if(path == "/notifications"){document.getElementById("m_notifications").style.color = "#ffe600";}
        if(path == "/settings"){document.getElementById("m_settings").style.color = "#ffe600";}
        if(path == "/account"){document.getElementById("m_account").style.color = "#ffe600";}
    },
    created: function() {
        if(localStorage.getItem("active_shop_together_alert")==1){
            this.active_shop_together_alert = 1;
        }
        // this.notifications.alert_no = 5;
        this.preset();
    }
}
</script>


// WEBPACK FOOTER //
// menubottom.vue?2909a794